/** NBSP, zero-width spaces, narrow no-break space, BOM — often pasted from Finder/browsers/PDFs. */
const INVISIBLE_WHITESPACE = /[\u00A0\u200B-\u200D\u202F\uFEFF]/g;

/**
 * Replaces invisible/special Unicode whitespace with a normal ASCII space.
 */
export function normalizeUnicodeWhitespace(name) {
  if (name == null || typeof name !== 'string') return '';
  return name.replace(INVISIBLE_WHITESPACE, ' ');
}

/**
 * Normalizes invisible whitespace, then spaces → underscores (aligned with backend / DB).
 */
export function withUnderscoresForUpload(name) {
  if (name == null || typeof name !== 'string') return '';
  return normalizeUnicodeWhitespace(name).replace(/ /g, '_');
}

/**
 * Returns a File suitable for multipart upload when the display name needs normalization.
 */
export function fileForUpload(file) {
  const safe = withUnderscoresForUpload(file.name);
  if (safe === file.name) return file;
  return new File([file], safe, { type: file.type, lastModified: file.lastModified });
}
